<template>
  <div :class="label ? 'vf-labeled' : ''">
    <label v-if="label">{{ label }}</label>
    <div>
      <input
        :type="type"
        required
        :formstate="formstate"
        :name="name"
        class="form-control"
        :placeholder="placeholder"
        v-model="model"
        @input="$emit('input', $event.target.value)"
      />
      <field-messages
        :state="formstate" 
        :name="name"
        show="$touched || $submitted"
        class="form-control-feedback"
      >
      <template>
			<span class="glyphicon glyphicon-ok form-control-feedback"></span>
		</template>

		<template v-for="(message, key) in messages" :slot="key">
			<div >
				<span class="glyphicon glyphicon-remove form-control-feedback"></span>
				<span class="has-error">{{ message }}</span>
			</div>
		</template>
      </field-messages>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'formstate',
    'type',
    'name',
    'placeholder',
    'label',
    'messages',
    'model',
  ],
  data() {
    return {
    };
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// FormInputCustom.vue?149fd6e6